import { useReduxState } from 'hooks';
import { FlexContainer, Search } from 'components/common';
import { Filters, FiltersActive } from 'components/common/filter';

interface Props {
  filterId: string;
}

/**
 * Search and filters for the responses list. Everything here ends up in the
 * URL, so an owner who opens one person's answers and comes back finds the
 * same page of the same filtered list.
 */
const CalendarEventFeedbackResponsesSubHeader = ({ filterId }: Props) => {
  const { messages } = useReduxState();

  return (
    <>
      <FlexContainer style={{ flexWrap: 'wrap', gap: 10, width: '100%' }}>
        <div style={{ minWidth: 240 }}>
          <Search
            placeholder={messages.usersSearchUsers}
            size="header"
            withUrl={true}
          />
        </div>

        <Filters
          allowMultiple={{ groups: true, userAttributes: true }}
          filterId={filterId}
          filters={{ groups: true, userAttributes: true }}
        />
      </FlexContainer>

      <FiltersActive filterId={filterId} />
    </>
  );
};

export default CalendarEventFeedbackResponsesSubHeader;
